var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-table', {
    attrs: {
      "bordered": "",
      "data-sign": "finance_hwc_statement_detail_cost_list",
      "columns": _vm.columns,
      "data-source": _vm.detailsData.fee_detail_list || [],
      "rowKey": function (record, index) {
        return index;
      },
      "pagination": false
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (ref) {
        var index = ref.index;
        return [_vm._v(" " + _vm._s(index + 1) + " ")];
      }
    }, {
      key: "amount",
      fn: function (ref) {
        var record = ref.record;
        return [_c('money-format', {
          attrs: {
            "num": record.amount,
            "currency": record.currency_code,
            "formatter": true
          }
        })];
      }
    }])
  });
};

var staticRenderFns = [];
export { render, staticRenderFns };